import PropTypes from "prop-types";
import React, { Component } from "react";
import TextField from "components/form/text-field";
import BrandCollection from "./collection";
import theme from "styles/theme";
import { List, ListItem } from "material-ui/List";
import { connect } from "react-redux";
import FlatButton from "material-ui/FlatButton";
import Avatar from "material-ui/Avatar";
import Toggle from "material-ui/Toggle";
import CircularProgress from "material-ui/CircularProgress";
import Caret from "components/icons/caret";
import debounce from "lodash/debounce";
import { format } from "lib/globalize-util";
import { Form } from "formsy-react";
import { style, merge, media, $ } from "glamor";
import BaseAvatar from "components/site-nav/avatar";
import NuORDERIcon from "components/icons/nuorder";
import { DATATEST } from "constants/integration";
import { initChurnZero, setChurnZeroContact } from "lib/churn-zero";
import { withLDConsumer } from "launchdarkly-react-client-sdk";

const brands = new BrandCollection();

const styles = {
    base: {
        position: "relative",
        display: "flex",
    },
    button: {
        height: theme.appBar.height + "px",
        flexShrink: 0,
        textAlign: "left",
        transition: "height 0.3s ease",
    },
    buttonLabel: {
        color: theme.palette.darkerGrey,
        fontSize: "20px",
        fontWeight: "normal",
        paddingLeft: "60px",
        paddingRight: "42px",
        maxHeight: "48px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: "24px",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        display: "-webkit-box",
        maxWidth: "320px",
        minWidth: "240px",
        transition: "all 0.3s ease",
    },
    noBrandLabel: {
        color: theme.palette.darkerGrey,
        fontSize: "20px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: "24px",
    },
    avatar: {
        position: "absolute",
        top: "50%",
        left: "8px",
        zIndex: 3,
        transform: "translateY(-50%)",
    },
    avatarNuOrder: {
        position: "absolute",
        top: "53%",
        left: "20px",
        zIndex: 3,
        transform: "translateY(-50%)",
    },
    icon: {
        position: "absolute",
        top: "50%",
        right: "12px",
        zIndex: 3,
        transform: "translateY(-50%)",
    },
    dropdown: {
        position: "absolute",
        top: "100%",
        left: 0,
        width: "400px",
        maxWidth: "65vw",
        background: "white",
        maxHeight: "0px",
        opacity: 0,
        zIndex: 4,
        transition: "all .3s ease-in",
        overflowY: "auto",
        padding: "0 24px",
        boxShadow: "0px 4px 12px " + theme.palette.grey,
    },
    dropdownOpen: {
        maxHeight: "326px",
        padding: "24px",
        opacity: 1,
    },
    listItem: {
        borderTop: "1px solid " + theme.palette.lightGrey,
    },
    listItemDisabled: {
        color: theme.palette.grey,
        textDecoration: "line-through",
    },
    listItemSelected: {
        color: theme.palette.primary1Color,
    },
    search: {
        width: "100%",
    },
    loading: {
        textAlign: "center",
        padding: "24px 0",
    },
};

class BrandPicker extends Component {
    static contextTypes = {
        me: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    static propTypes = {
        style: PropTypes.object,
        buttonStyle: PropTypes.object,
        page: PropTypes.string,
    };

    responsiveStyles = merge(
        media(
            "(min-width: 240px) AND (max-width: 689px)",
            $(" .brandPicker", {
                minWidth: "60px !important",
            })
        )
    );

    constructor(props) {
        super(props);

        this.state = {
            syncStatus: 0,
            isOpen: false,
            searchTerm: "",
            showDisabled: false,
        };

        this.handleSearchChange = debounce(this.handleSearchChange, 500);
    }

    UNSAFE_componentWillMount() {
        this.context.me.on("logout", this.handleLogout, this);
        window.addEventListener("touchstart", this.handleClickAway);
        window.addEventListener("click", this.handleClickAway);
    }

    componentDidMount() {
        const { me } = this.context;

        if (me.account_type === "buyer" && global.location.pathname.includes("/dashboard")) {
            brands.fetch({
                data: {},
                success: () => {
                    this.setState({ syncStatus: 2 });
                },
            });
        }

        if (this.props.flags?.initChurnZeroNu30084 && this.props.activeBrand) {
            initChurnZero({
                callback: () => setChurnZeroContact({ brand: this.props.activeBrand, me }),
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { isFetchingMerchantEnablements } = this.props;
        if (isFetchingMerchantEnablements && this.state.syncStatus !== 0) {
            this.setState({ syncStatus: 0 });
        }
    }

    componentWillUnmount() {
        this.context.me.off("logout", this.handleLogout, this);
        window.removeEventListener("touchstart", this.handleClickAway);
        window.removeEventListener("click", this.handleClickAway);
    }

    handleSearchChange = (e, value) => {
        this.setState({ searchTerm: value });
    };

    handleClickAway = (e) => {
        const { isOpen } = this.state;
        if (e.defaultPrevented || !isOpen) {
            return;
        }

        const el = this.refs.main;
        if (
            (e.target !== el && e.target === window) ||
            (document.documentElement.contains(e.target) && !this.isDescendant(el, e.target))
        ) {
            this.setState({ isOpen: false });
        }
    };

    isDescendant(parent, child) {
        let node = child.parentNode;

        while (node !== null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }

        return false;
    }

    handleLogout() {
        brands.reset();
    }

    handleDropdownOpen = () => {
        if (this.state.syncStatus === 0) {
            this.setState({ syncStatus: 1 });
            let data = {};
            if (this.context.me.account_type === "nuorder") {
                data = {
                    active: true,
                };
            }
            brands.fetch({
                data,
                success: () => {
                    this.setState({ syncStatus: 2 });
                },
            });
        }
        this.setState({ isOpen: !this.state.isOpen });
    };

    handleDisabledBrandsToggle = (e, on) => {
        if (this.state.syncStatus === 2 && on) {
            brands.fetch({
                data: {
                    active: false,
                },
                remove: false,
                success: () => {
                    this.forceUpdate();
                },
            });
            this.setState({ syncStatus: 3, showDisabled: true });
        } else {
            this.setState({ showDisabled: on });
        }
    };

    handleChangeBrand(brand, e) {
        e.preventDefault();
        // Save active brand
        if (!brand.active) {
            this.changeLocation(brand);
        } else {
            this.context.me.save(
                {
                    last_brand: brand._id,
                },
                {
                    patch: true,
                    success: () => {
                        this.changeLocation(brand);
                    },
                    error: () => {
                        this.changeLocation(brand);
                    },
                }
            );
        }
        this.setState({ isOpen: false });
    }

    changeLocation(brand) {
        const { activeBrand } = this.props;

        if (!brand.active) {
            // only allow them in management
            this.context.router.push(`/brand/${brand._id}/management`);
        } else if (!activeBrand || activeBrand._id !== brand._id) {
            const defaultBrandPage = ["brand", brand._id];

            const currentPath = global.location.pathname.split("/").filter((fragment) => fragment !== "");
            const currentRoot = currentPath[0];

            let redirectTo = defaultBrandPage;

            // In an interest of time and not diving deep into debugging, lets just for a browser reload
            this.props.onSetViewAs(undefined);
            this.props.onClearCompany();
            setChurnZeroContact({ brand, me: this.context.me });
            this.context.router.push(`/${redirectTo.join("/")}`);
        }
    }
    render() {
        //let Filters;
        const { me } = this.context;
        const { buttonStyle, activeBrand, viewport } = this.props;
        const { syncStatus, isOpen, searchTerm, showDisabled } = this.state;
        const shrinkPicker = viewport === "mobile" || viewport === "phablet";
        let showDisabledBrands = null;

        const isDashboard = global.location.pathname.includes("/dashboard");

        if (me.account_type === "nuorder") {
            showDisabledBrands = (
                <ListItem
                    primaryText={format("Show disabled brands")}
                    leftCheckbox={<Toggle onToggle={this.handleDisabledBrandsToggle} />}
                    data-test={
                        showDisabled
                            ? DATATEST.SHOW_DISABLED_BRANDS_TOGGLE.ENABLED
                            : DATATEST.SHOW_DISABLED_BRANDS_TOGGLE.DISABLED
                    }
                />
            );
        }
        // eslint-disable-next-line no-useless-escape
        const searchParam = new RegExp((searchTerm || "").replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), "i");
        let matchingLastBrand = me.account_type !== "buyer" || !isDashboard; // we only care about check for buyer
        const matchingBrands = brands
            .filter((model) => {
                if (me.account_type === "nuorder" && !showDisabled && !model.active) {
                    return false;
                }
                if (searchTerm) {
                    return searchParam.exec(model.name);
                }
                return true;
            })
            .map((model) => {
                const initials = model.name.charAt(0).toUpperCase();
                if (!matchingLastBrand) {
                    if (model._id === me.last_brand) {
                        matchingLastBrand = true;
                    }
                }
                return (
                    <ListItem
                        key={model._id}
                        leftAvatar={<Avatar>{initials}</Avatar>}
                        primaryText={model.name}
                        data-test={model.toDataTest("name")}
                        onClick={this.handleChangeBrand.bind(this, model)}
                        style={Object.assign(
                            {},
                            styles.listItem,
                            !model.active && styles.listItemDisabled,
                            activeBrand && model._id === activeBrand._id && styles.listItemSelected
                        )}
                    />
                );
            });

        let searchBox = null;
        if (brands.length > 3) {
            searchBox = (
                <Form>
                    <TextField
                        name="search"
                        dataTest={DATATEST.BRAND_SEARCH}
                        style={styles.search}
                        onChange={this.handleSearchChange}
                        defaultValue={searchTerm || ""}
                        placeholder={format("Search")}
                    />
                </Form>
            );
        }

        let label = format("Select Brand");
        if (
            global.location.pathname.includes("/browse/brands") ||
            (global.location.pathname.indexOf("/site/") === 0 && !global.location.pathname.includes("/settings")) ||
            (isDashboard && !me.last_brand)
        ) {
            label = "NuORDER";
        }
        label = activeBrand ? activeBrand.name : label;
        if (!matchingLastBrand) {
            label = "NuORDER";
        }
        let content = null;
        if (syncStatus === 1) {
            content = (
                <div style={styles.loading}>
                    <CircularProgress />
                </div>
            );
        } else if (syncStatus > 1) {
            if (showDisabledBrands?.length || matchingBrands?.length) {
                content = (
                    <List data-test={DATATEST.BRAND_LIST}>
                        {showDisabledBrands}
                        {matchingBrands}
                    </List>
                );
            } else if (me.account_type === "buyer") {
                content = (
                    <div data-test={DATATEST.NOT_CONNECTED_TO_ANY_BRAND} style={styles.noBrandLabel}>
                        {format("You are not connected to any brands - browse live events to connect")}
                    </div>
                );
            }
        }

        return (
            <div {...merge(styles.base, this.props.style)} {...this.responsiveStyles} ref="main">
                <FlatButton
                    className="brandPicker"
                    onClick={this.handleDropdownOpen}
                    style={Object.assign({}, styles.button, buttonStyle)}
                    data-test={DATATEST.BRAND_PICKER}
                >
                    {activeBrand && matchingLastBrand && (
                        <BaseAvatar
                            key="0"
                            dark={true}
                            label={activeBrand._initials}
                            src={`//cdn1.nuorder.com/brands/${activeBrand.settings.dashboard_logo_image}.png`}
                            style={styles.avatar}
                        />
                    )}
                    {(!activeBrand || !matchingLastBrand) && <NuORDERIcon key="nu" style={styles.avatarNuOrder} />}
                    {!shrinkPicker && (
                        <div data-test={DATATEST.ACTIVE_BRAND} key="1" {...merge(styles.buttonLabel)}>
                            {label}
                        </div>
                    )}
                    {!shrinkPicker && <Caret key="2" color="#37474F" style={styles.icon} />}
                </FlatButton>
                <div {...merge(style(styles.dropdown), isOpen && style(styles.dropdownOpen))}>
                    {searchBox}
                    {content}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isFetchingMerchantEnablements: state.merchantEnablements.isFetchingMerchantEnablements,
});

export default connect(mapStateToProps, {})(withLDConsumer()(BrandPicker));
